<template lang="html">
  <div class="content" v-loading.fullscreen.lock="loading" element-loading-text="数据量巨大，请耐心等待..." element-loading-background="rgba(0, 0, 0, 0.8)">
    <search :params.sync="params" :showCharts="showCharts" />
    <div class="chart-canvas" ref="myEchart"></div>
    <div class="chart-canvas" ref="lineEchart"></div>
    <div class="chart-canvas" ref="constructEchart"></div>
    <div class="chart-wrap">
      <div class="pv-total">PV数：{{ pvTotal }}</div>
      <div class="chart-canvas" ref="ipEchart"></div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import axios from "axios";
import qs from "qs";

import search from '../../components/search';

export default {
  components: {
    search
  },
  data() {
    return {
      loading: false,
      params: {},
      pvTotal: ''
    };
  },
  mounted() {
    
  },
  methods: {
    showCharts() {
      // this.loading = true;
      // axios
      //   .all([this.fetch(), this.fetchRatio(), this.fetchConstruct()])
      //   .then(values => {
      //     this.loading = false;
      //   });
      this.chart = this.chart || echarts.init(this.$refs.myEchart, "light");
      this.ratioChart = this.ratioChart || echarts.init(this.$refs.lineEchart, "light");
      this.constructChart = this.constructChart || echarts.init(this.$refs.constructEchart, "light");
      this.pvChart = this.pvChart || echarts.init(this.$refs.ipEchart, "light");

      window.addEventListener("resize", () => {
        this.chart.resize();
        this.ratioChart.resize();
        this.constructChart.resize();
        this.pvChart.resize();
      });
      this.chart.showLoading();
      this.ratioChart.showLoading();
      this.constructChart.showLoading();
      this.pvChart.showLoading();

      this.fetch().then(values => {
        this.chart.hideLoading();
        this.pvChart.hideLoading();
      }).then(() => {
        this.fetchRatio().then(values => {
          this.ratioChart.hideLoading();
        }).then(() => {
          this.fetchConstruct().then(values => {
            this.constructChart.hideLoading();
          });
        });
      });
    },
    fetch() {
      const { clientType, dateRange, type, pageId } = this.params;
      return axios.get(`/timeRatio/all?${qs.stringify({
        client: clientType,
        match: JSON.stringify({ [type]: this.params[type] }),
        dateRange
      })}`).then(res => {
        // 筛选数据
        const { data } = res.data;

        const days = data.map(item => item["key_as_string"].replace(' ', '\n'));

        const seriesData1 = data.map(item =>
          item["avg_ready"].value ? item["avg_ready"].value.toFixed(2) : 0
        );
        const seriesData2 = data.map(item =>
          item["avg_load"].value ? item["avg_load"].value.toFixed(2) : 0
        );

        // pv图
        const pvData = data.map(item => item["doc_count"]);
        this.setPvChartData(days, pvData);
        this.pvTotal = res.data.total;

        // 大盘数据
        if (pageId) {
          axios.get(`/timeRatio/all?${qs.stringify({
            client: clientType,
            dateRange
          })}`).then(res => {
            const { data } = res.data;
            const seriesData3 = data.map(item =>
              item["avg_ready"].value ? item["avg_ready"].value.toFixed(2) : 0
            );
            const seriesData4 = data.map(item =>
              item["avg_load"].value ? item["avg_load"].value.toFixed(2) : 0
            );
            this.setChartData(days, seriesData1, seriesData2, seriesData3, seriesData4);
          })
        } else {
          this.setChartData(days, seriesData1, seriesData2);
        }
      })
    },
    setChartData(days, seriesData1, seriesData2, seriesData3, seriesData4) {
      const option = {
        title: {
          text: "首页速度"
        },
        grid: {
          left: 10,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" + params[i].marker + params[i].seriesName + " : " + params[i].value + "ms";
            }
            return relVal;
          }
        },
        legend: {
          data: ["白屏时间", "整屏时间"]
        },
        xAxis: {
          type: "category",
          data: days,
          boundaryGap: false
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            data: seriesData1,
            name: "白屏时间",
            type: "line"
          },
          {
            data: seriesData2,
            name: "整屏时间",
            type: "line"
          }
        ]
      };

      if (seriesData3 && seriesData4) {
        option.legend.data.push('大盘白屏时间', '大盘整屏时间');
        option.series.push({
          data: seriesData3,
          name: "大盘白屏时间",
          type: "line",
          lineStyle: {
            color: '#ccc',
            type: 'dashed'
          },
          itemStyle: {
            color: '#ccc'
          }
        });
        option.series.push({
          data: seriesData4,
          name: "大盘整屏时间",
          type: "line",
          lineStyle: {
            color: '#ccc',
            type: 'dashed'
          },
          itemStyle: {
            color: '#ccc'
          }
        });
      } else {
        // 大盘数据从有到无需要清除掉
        this.chart.clear();
      }
      // 把配置和数据放这里
      this.chart.setOption(option);
    },
    // 占比数据
    fetchRatio() {
      const { clientType, dateRange, type } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ [type]: this.params[type] }),
        dateRange
      };

      return axios
        .get(`/timeRatio/allRatio?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          let days = data.map(item => item["key_as_string"].replace(' ', '\n'));
          let seriesData1 = [];
          let seriesData2 = [];
          let seriesData3 = [];
          let seriesData4 = [];
          data.map(item => {
            const totle = item["doc_count"];
            item["data_range"].buckets.map(child => {
              if (child["key"] === "0-1") {
                seriesData1.push(
                  Math.round((child["doc_count"] / totle) * 10000) / 100.0
                );
              }
              if (child["key"] === "1-2") {
                seriesData2.push(
                  Math.round((child["doc_count"] / totle) * 10000) / 100.0
                );
              }
              if (child["key"] === "2-3") {
                seriesData3.push(
                  Math.round((child["doc_count"] / totle) * 10000) / 100.0
                );
              }
              if (child["key"] === "3-m") {
                seriesData4.push(
                  Math.round((child["doc_count"] / totle) * 10000) / 100.0
                );
              }
            });
          });
          this.setRatioChartData(
            days,
            seriesData1,
            seriesData2,
            seriesData3,
            seriesData4
          );
        })
    },
    setRatioChartData(days, seriesData1, seriesData2, seriesData3, seriesData4) {
      const option = {
        title: {
          text: "速度分布"
        },
        grid: {
          left: 10,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" + params[i].marker + params[i].seriesName + " : " + params[i].value + "%";
            }
            return relVal;
          }
        },
        legend: {
          data: ["0~1s内", "1~2s内", "2~3s内", "3s以上"]
        },
        xAxis: {
          type: "category",
          data: days,
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} %"
          }
        },
        series: [
          {
            data: seriesData1,
            name: "0~1s内",
            type: "line"
          },
          {
            data: seriesData2,
            name: "1~2s内",
            type: "line"
          },
          {
            data: seriesData3,
            name: "2~3s内",
            type: "line"
          },
          {
            data: seriesData4,
            name: "3s以上",
            type: "line"
          }
        ]
      };
      // 把配置和数据放这里
      this.ratioChart.setOption(option);
    },
    // 柱状图
    fetchConstruct() {
      const { clientType, dateRange, type } = this.params;
      const query = {
        client: clientType,
        match: JSON.stringify({ [type]: this.params[type] }),
        dateRange
      };
      return axios
        .get(`/timeRatio/allConstruct?${qs.stringify(query)}`)
        .then(response => {
          const { data } = response.data;
          const days = data.map(item => item["key_as_string"].replace(' ', '\n'));
          const treeData = [
            {
              name: "APP cache",
              title: "avg_cache"
            },
            {
              name: "DNS",
              title: "avg_dns"
            },
            {
              name: "TCP",
              title: "avg_tcp"
            },
            {
              name: "网络请求耗时",
              title: "avg_req"
            },
            {
              name: "数据传输耗时",
              title: "avg_res"
            },
            {
              name: "DOM解析耗时",
              title: "avg_dom"
            },
            {
              name: "DOMContentLoaded回调函数耗时",
              title: "avg_readycb"
            },
            {
              name: "资源加载耗时",
              title: "avg_fasrt"
            },
            {
              name: "Load回调函数耗时",
              title: "avg_loadcb"
            }
          ];
          const series = treeData.map(item => {
            return {
              data: data.map(key => (key[item.title].value || 0).toFixed(2)),
              name: item.name,
              stack: "q",
              type: "bar",
              barWidth: 20
            };
          });
          this.setConstructChartData(days, series);
        })
    },
    setConstructChartData(days, series) {
      const option = {
        title: {
          text: "速度柱图"
        },
        grid: {
          left: 10,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: "axis",
          formatter: function(params) {
            var relVal = params[0].name;
            for (var i = 0, l = params.length; i < l; i++) {
              relVal +=
                "<br/>" + params[i].marker + params[i].seriesName + " : " + params[i].value + "ms";
            }
            return relVal;
          }
        },
        legend: {
          data: series.map(item => item.name)
        },
        xAxis: {
          type: "category",
          data: days
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value} ms"
          }
        },
        series
      };
      // 把配置和数据放这里
      this.constructChart.setOption(option);
    },
    // pv趋势图
    setPvChartData(days, series) {
      const option = {
        title: {
          text: "PV趋势图"
        },
        grid: {
          left: 10,
          right: 10,
          containLabel: true
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: ["PV"]
        },
        xAxis: {
          type: "category",
          data: days,
          boundaryGap: false
        },
        yAxis: {
          type: "value"
        },
        series: [
          {
            name: "PV",
            type: "line",
            data: series
          }
        ]
      };
      // 把配置和数据放这里
      this.pvChart.setOption(option);
    }
  }
};
</script>

<style lang="css" scoped>
.content {
  padding: 30px;
}
.chart-canvas {
  height: 400px;
  width: 100%;
  margin-top: 30px;
}
.chart-wrap {
  position: relative;
}
.pv-total {
  position: absolute;
  left: 120px;
  top: 4px;
  font-size: 14px;
}
</style>
